/** Warm clips at the first gesture, alongside the existing audio unlock.
 * The untouched title doesn't download audio and muted devices stay quiet. */
export default defineNuxtPlugin(() => {
  const sfx = useSfx()
  const warm = () => {
    window.removeEventListener('pointerdown', warm, true)
    window.removeEventListener('keydown', warm, true)
    sfx.preload()
  }
  window.addEventListener('pointerdown', warm, { capture: true, passive: true })
  window.addEventListener('keydown', warm, { capture: true })
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) sfx.stop()
  })
  window.addEventListener('pagehide', () => sfx.stop())
})
